/**
 * Which build is on screen. The values are constants baked in at build time
 * (vite.config.ts `define`), so this file is the only place that reads them
 * and the only place a component needs to import.
 */
export interface BuildInfo {
  version: string
  /** ISO 8601, the moment `vite build` (or the dev server) started. */
  builtAt: string
  /** Short commit hash, or empty when the build had no git checkout. */
  commit: string
}

export const buildInfo: BuildInfo = {
  version: __BUILD_VERSION__,
  builtAt: __BUILD_TIME__,
  commit: __BUILD_COMMIT__,
}

/** `v0.1.0 · 15 Sep 2026 · c3fcf49` — the commit is omitted when unknown. */
export const formatBuildStamp = (info: BuildInfo, locale = 'en-US'): string => {
  const date = new Date(info.builtAt)
  const day = Number.isNaN(date.getTime())
    ? info.builtAt
    : new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short', year: 'numeric' }).format(
        date,
      )
  return [`v${info.version}`, day, info.commit].filter(Boolean).join(' · ')
}
